// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--932f2 footer-module--sharedListItemStyles--b0528";
export var icon = "footer-module--icon--9380e";
export var list = "footer-module--list--7fb02";
export var listItem = "footer-module--listItem--bd21a footer-module--sharedListItemStyles--b0528";
export var sharedListItemStyles = "footer-module--sharedListItemStyles--b0528";